export const divider = {
  colorScheme: {
    light: {
      root: {
        color: '#dadada',
      },
    },
    dark: {
      root: {
        color: '#dadada',
      },
    },
  },
};
